module.exports = __webpack_public_path__ + "img/videobj.a9c54cb6.png";